﻿import React, { useState, useEffect } from 'react';
import { StandardReference } from '../models/Standards/standard-reference';
import { LookupItem } from '../models/lookup-item';
import { StandardSearchRequest } from '../models/standard-search-request';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import TextBox from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import Button from 'devextreme-react/button';

import DataGrid, {
    Column,
    FilterRow,
    Selection,
    HeaderFilter,
    Paging
} from 'devextreme-react/data-grid';

export interface Props {
    onImportSelection?: (item: StandardReference) => void;
    onCancel?: () => void;
}

export default function StandardsSearch(props: Props) {
    const [catalogNumberFilter, setCatalogNumberFilter] =
        useState<string>();

    const [lotNumberFilter, setLotNumberFilter] =
        useState<string>();

    const [standardManufacturers, setStandardManufacturers] =
        useState<LookupItem[]>();

    const [selectedManufacturer, setSelectedManufacturer] =
        useState<LookupItem>();

    const [standardReferenceItems, setStandardReferenceItems] =
        useState<StandardReference[]>();

    const [selectedStandardReferenceItem, setSelectedStandardReferenceItem] =
        useState<StandardReference>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

    return (
        <div>
            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-15">
                    <label className="textbox-label">Manufacturer</label>
                    <SelectBox id="manufacturersSelectBox"
                        showClearButton={true}
                        placeholder='manufacturer'
                        displayExpr='description'
                        dataSource={standardManufacturers ?
                            standardManufacturers : []}
                        onValueChanged={standardsManufacturerValueChanged}
                        value={selectedManufacturer ?
                            selectedManufacturer : undefined} />
                </div>

                <div className="pw-form-unit pw-comp-15">
                    <label className="textbox-label">Catalog #</label>
                    <TextBox id="catalogNumber"
                        className="textbox"
                        onValueChanged={catalogNumberFilterValueChanged}
                        showClearButton={true}
                        placeholder="catalog number" value={catalogNumberFilter ?
                            catalogNumberFilter : undefined} />
                </div>
                <div className="pw-form-unit pw-comp-15">
                    <label className="textbox-label">Lot #</label>
                    <TextBox id="lotNumber"
                        className="textbox"
                        onValueChanged={lotNumberFilterValueChanged}
                        showClearButton={true}
                        placeholder="lot number" value={lotNumberFilter ?
                            lotNumberFilter : undefined} />
                </div>

                <div className="pw-right-align-content">
                    <Button id="searchButton" text="Search" icon="find" type="success"
                        className="pw-margin-right-1 pw-button-right-labeled-textbox"
                        hint="search"
                        height={'1.8rem'}
                        onClick={onSearchClick} />
                </div>
            </div>

            <div className="pw-comp-row">
                <DataGrid
                    width='100%'
                    height="25rem"
                    dataSource={standardReferenceItems ?
                        standardReferenceItems : []}
                    onSelectionChanged={standardItemSelectionChanged}
                    wordWrapEnabled={true}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <Selection mode={'single'} />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />
                    <Paging enabled={false} />

                    <Column dataField='catalogNumber' caption="Catalog #" dataType="string" width='12rem' />
                    <Column dataField='productName' dataType="string" />
                    <Column dataField='currentLot' caption="Current Lot #" dataType="string" width='12rem' />
                    {/*
                    <Column dataField='dateExpired' dataType="date" width='12rem' format="MM/dd/yyyy" />
                    */}
                </DataGrid>
            </div>

            <div className="pw-comp-row">
                <div className="pw-centered-buttons-container">
                    <Button id="applySelectionButton"
                        className="pw-button"
                        text="Apply" type="success"
                        hint="apply selection"
                        height='2.6em'
                        onClick={onApplyClick} />

                    <Button id="cancelButton"
                        className="pw-button"
                        text="Cancel" type="normal"
                        hint="cancel"
                        height='2.6em'
                        onClick={onCancelClick} />
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }
        </div>
    );

    function standardItemSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedStandardReferenceItem(e.selectedRowsData[0]);
        }
    }

    function catalogNumberFilterValueChanged(e: any) {
        setCatalogNumberFilter(e.value);
    }

    function lotNumberFilterValueChanged(e: any) {
        setLotNumberFilter(e.value);
    }

    function standardsManufacturerValueChanged(e: any) {
        setSelectedManufacturer(e.value);
    }

    function onApplyClick() {
        if (selectedStandardReferenceItem && props.onImportSelection)
            props.onImportSelection(selectedStandardReferenceItem);
    }

    function onCancelClick(e: any) {
        if (props.onCancel)
            props.onCancel();
    }

    function onSearchClick() {
        //if (selectedManufacturerId && (catalogNumberFilter || lotNumberFilter)) {

        if (selectedManufacturer && (catalogNumberFilter || lotNumberFilter)) {

            const request: StandardSearchRequest = {
                manufacturerId: selectedManufacturer.id,
                catalogNumber: catalogNumberFilter,
                lotNumber: lotNumberFilter
            };

            onSearch(request);
        }
        //TODO:
        else {
            // XXX.publish(ModalSubscriberTopic, { modalType: InformationModal, message: "Please enter search parameters." });
        }
    }

    async function onSearch(request: StandardSearchRequest) {
        await CrudFunctions.postData("standards/searchstandardreferences", request)
            .then((data) => {
                setStandardReferenceItems(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Search Results");
            });
    }

    //GET functions

    async function getStandardsManufacturers() {
        await CrudFunctions.getData("standards/standardsmanufacturers")
            .then(data => {

                setStandardManufacturers(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Manufacturers");
            });
    }

    function getAllData() {
        getStandardsManufacturers();
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}
